import { env } from 'constants/env'
import api from '../../api'
import { QuotaMonthType } from './interfaces'
import { Offices } from 'constants/enums'

export const getActiveQuotaMonthsByOffice = async (
  office: Offices
): Promise<QuotaMonthType[]> => {
  const { data } = await api.get(`rascunho/v2/listar-mescota-aberto`, {
    params: {
      codigoEscritorio: office
    }
  })

  return data
}

// NOTE: W.I.P
export const getQuotaMonthsByOffices = async (
  offices: string[]
): Promise<QuotaMonthType[]> => {
  const { data } = await api.post(`rascunho/v2/listar-mescota`, offices)

  return data
}

export const getYearMonthQuota = async (): Promise<QuotaMonthType[]> => {
  const { data } = await api.get(
    `${env.commercialStructure}/${env.apiVersion}/ListaAnoMesCota`
  )

  return data.Result
}
